
import { DecimalPipe } from '@angular/common';
import { MAIN_SECTION, ORDER_PAYMENT_LIST_TITLE, MAIN_SECTION_LOCALIZED_PROPERTIES, DETAILS_SECTION, DETAILS_SECTION_LOCALIZED_PROPERTIES } from './order-payment-c-list.constants';
import { ExportFileFormat } from 'app/layout/export-overlay';
import OrderPaymentAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/process/order-payment/order-payment.entity';
import { OrdersPaymentCListCommonExportProcessor } from './order-payment-c-list-common';

export class OrdersPaymentCListExcelExportProcessor extends OrdersPaymentCListCommonExportProcessor {
  constructor(decimalPipe: DecimalPipe) {
    super(decimalPipe);
  }

  override onInit() {
    this.setSectionTitle(MAIN_SECTION, ORDER_PAYMENT_LIST_TITLE);
    if (this.context.format === ExportFileFormat.CSV) {
      this.setSectionOptions(MAIN_SECTION, { ignoreTitleOnOutput: true });
    }
    this.localizeItemProperties(MAIN_SECTION, MAIN_SECTION_LOCALIZED_PROPERTIES);

    this.setSectionTitle(DETAILS_SECTION, 'Detalles');
    this.localizeItemProperties(DETAILS_SECTION, DETAILS_SECTION_LOCALIZED_PROPERTIES);
  }

  override onAddData(item: OrderPaymentAttributes) {
    this.addToSection(MAIN_SECTION, this.transformForMainSection(item));
    this.addToSection(DETAILS_SECTION, this.transformForDetailsSection(item));
  }
}
